<template>
  <header id="header">
    <b-navbar toggleable="lg">
      <b-navbar-brand class="brand">
        <a href="https://www.westjr.co.jp/"><img id="logo" src="../../assets/images/jr_logo.svg"  width="41" alt="JR西日本旅客鉄道株式会社"></a>
        <router-link id="delay" :to="{ name: 'SpSiteTop' }">遅延証明書</router-link>
      </b-navbar-brand>

      <b-navbar-toggle id="menuBtn" target="nav-collapse">
        <span id="menu_text" class="navbar-toggler-icon"></span>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-if="!isSiteTop" class="nav-item-area" v-on:click="clickArea(0, { name: 'SpSiteTop' })">トップページ</b-nav-item>
          <b-nav-item v-if="!isSiteTop" v-for="header_area in header_areas" v-bind:key="header_area.area_id" class="nav-item-area" v-on:click="clickArea(header_area.area_id, { name: 'SpLineList', params: { areaId: header_area.area_id } })">{{ header_area.display_name }}エリア</b-nav-item>
          <b-nav-item href="https://trafficinfo.westjr.co.jp/readme.html#delay" target="_blank" class="nav-item-outeline">サービス概要<img src="../../assets/images/delay_icon_gray.png"/></b-nav-item>
          <b-nav-item href="https://trafficinfo.westjr.co.jp/qanda.html#delay_top" target="_blank" class="nav-item-outeline">Q&A<img src="../../assets/images/delay_icon_gray.png"/></b-nav-item>
          <b-nav-item href="/sp/guideline/outline" target="_blank" class="nav-item-outeline">利用規約<img src="../../assets/images/delay_icon_gray.png"/></b-nav-item>
       </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'sp-site-header',
  created () {
    this.$store.dispatch('areaLine/all')
  },
  computed: {
    ...mapState('areaLine', {
      header_areas: state => state.areas,
      areaId: state => state.areaId
    }),
    isSiteTop () {
      return this.$route.name === 'SpSiteTop'
    }
  },
  methods: {
    clickArea (areaId, path) {
      if (this.areaId === areaId) {
        this.$store.commit('loading/setStatus', true)
        setTimeout(() => {
          this.$store.dispatch('areaLine/reload')
        })
      } else {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/variables';
li.nav-item.nav-item-area {
  border-bottom: solid 1px #e6e6e6;
}
nav.navbar {
  padding-left: 0;
  padding-bottom: 0;
  box-shadow: 0 0.3rem 0.5rem rgba(0,0,0,0.075) !important;
}
li.nav-item {
  padding-left: 16px;
}
a {
  &#delay {
    margin-left: 16px;
    font-weight: 600;
  }
}
.brand {
  padding-left: 16px;
  strong {
    color: $primary;
    margin-left: 1rem;
    font-size: 1.2rem;
  }
}
.navbar.navbar-light.navbar-expand-lg {
  padding-right: 0;
}
.navbar-nav {
  border-bottom: solid 1px #e6e6e6;
  .nav-item {
    line-height: 40px;
    font-size: 1.0rem;
    font-weight: 600;
    a {
      color: $text-color;
    }
  }
}
.navbar-toggler {
  border: none !important;
  outline: none !important;
  .navbar-toggler-icon {
    font-size: 0.6rem;
    padding-top: 1.5rem;
    margin-bottom: 0.65rem;
    text-align: center;
    width: 2.5rem;
    height: 1.5rem;
    font-weight: normal;
    background: no-repeat center top;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30'  xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(128, 128, 128, 1)'  stroke-width='3' stroke-miterlimit='10' d='M4 7L23 23M23 7L4 23'/%3E%3C/svg%3E");
    &:after {
      display: inline-block;
      content: "閉じる";
    }
  }
  &.collapsed {
    .navbar-toggler-icon {
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30'  xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(128, 128, 128, 1)'  stroke-width='3' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
      &:after {
        display: inline-block;
        content: "メニュー";
      }
    }
  }
}
.nav-link img {
    margin-left: 0.2rem;
    margin-bottom: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/sp/SpSiteHeader.vue